var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.link ? 'a' : 'button',{tag:"component",staticClass:"botao-principal",on:{"click":(e) => _vm.$emit('click', e)}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }